import React from 'react'

export default React.memo(function AppProvider({
  children
}: {
  children: any
}) {
  return <>{children}</>
})
